import React from "react";
import GlobalApproval from "../../../components/mui/Dialogue/GlobalApproval";
import { useSelector } from "react-redux";
import {
  approveOrRejectProcurementHead,
  getSale,
} from "../../../redux/features/assetManagementSlice";
import { savePaginationData } from "../../../redux/features/globalDatagridSlice";

const ProcureHeadApproval = ({ dispatchParams, loading, saleId,disable }) => {
  const { paginationData } = useSelector((state) => state.globalDataGrid);
  return (
    <GlobalApproval
      disabled={disable}
      title={"Approve"}
      displayNote={"Are you sure? you want to approve this Request..?"}
      api={approveOrRejectProcurementHead({saleId:saleId, status: 1})}
      upDateCall={getSale(dispatchParams)}
      updatePaginationCall={savePaginationData({
        ...paginationData,
        openAnchor: false,
      })}
      loading={loading}
    />
  );
};

export default ProcureHeadApproval;
